import * as THREE from 'three';
import { gsap,Power2,Power3 } from "gsap";
import nextIMG from "./../images/next-project.svg";
import nextIMGLight from "./../images/next-project-light.svg";


export default class ProjectCanvas {

    constructor(obj) {

        this.container = obj;
        this.currentScroll = 0;
        this.go = true;
        this.xm = 11.2;
        this.ym = 30.4;
        this.asR = 1;
        this.time = -1;
        this.devicePixelRatio = 1.;
        this.scrollSpeed = 0;
        this.tl = new gsap.timeline({repeat: -1,repeatDelay:4});

        this.images = [...document.querySelectorAll('.canvas-image')];
        

        const opt = {
            type: THREE.HalfFloatType
        }
        

        this.dpMouseLeaveHander = this.dpMouseLeave.bind(this);
        this.dpMouseEnterHander = this.dpMouseEnter.bind(this);


        this.mouse = {
            last: new THREE.Vector2(),
            current: new THREE.Vector2(0.5,0.5),
            velocity: new THREE.Vector2(),
            updateVelocity: false,
            lastTime: null,
        };


        /*------------------------------
        Renderer
        ------------------------------*/
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        this.renderer.autoClear = true;
        this.renderer.setPixelRatio(window.devicePixelRatio);
        if (window.matchMedia('(min-width:1200px)').matches) {
            this.renderer.setPixelRatio(Math.min(window.devicePixelRatio,1.0));
        }
        //this.renderer.setPixelRatio(0.5);
        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;
        this.renderer.setSize( this.width, this.height );
        this.container.appendChild( this.renderer.domElement );

        this.renderTargetImage = new THREE.WebGLRenderTarget(this.width*window.devicePixelRatio, this.height*window.devicePixelRatio);

        this.renderTargetPing = new THREE.WebGLRenderTarget(this.width, this.height,opt);
        this.renderTargetPong = new THREE.WebGLRenderTarget(this.width, this.height,opt);

        /*------------------------------
        Scene & Camera
        ------------------------------*/
        this.scene = new THREE.Scene();
        this.sceneBG = new THREE.Scene();
        this.sceneFinal = new THREE.Scene();
        //this.scene.background = new THREE.Color('#000000');
        this.camera = new THREE.PerspectiveCamera( 70, this.width/this.height, 100, 2000 );
        this.camera.position.z = 600;
        this.camera.aspect = this.width/this.height;
        this.camera.fov = 2*Math.atan( (this.height/2)/600 )* (180/Math.PI);

        /*------------------------------
        Clock
        ------------------------------*/
        this.clock = new THREE.Clock();
    }

    lerp(start, end, amount) {
        return (1 - amount) * start + amount * end;
    }

    init() {

        this.addNextTexture();
        this.addImages();
        if (document.querySelector( '.project-video' ) != null) {
            this.addVideo();
        }
        this.addRipples();
        this.addFinal();
        this.resize();
        this.render();
        this.setupResize();
        this.onScroll();

        window.addEventListener( 'mousemove', this.mouseMovement.bind(this));
        window.addEventListener( 'touchmove', this.mouseMovement.bind(this));
        window.addEventListener( 'touchend', this.touchEnd.bind(this));

        document.querySelector('.project__next-wrap').addEventListener('mouseenter', this.dpMouseEnterHander);
        document.querySelector('.project__next-wrap').addEventListener('mouseleave', this.dpMouseLeaveHander);


    }

    dpMouseEnter() {
        this.tl.pause();
        gsap.to(this.nextMeshMAT.uniforms.uTwist,{
            value: 2.0,
            duration: 1.0,
            ease: Power3.easeInOut
        });
    }

    dpMouseLeave() {
        var tl = new gsap.timeline();
        tl.to(this.nextMeshMAT.uniforms.uTwist,{
            value: 0.0,
            duration: 1.0,
            ease: Power3.easeInOut
        }).add(function () {
            this.tl.play('end');
        }.bind(this))
    }

    setNextPosition() {
        
        if (document.querySelector('.project__next') != null) {
            let bounds = document.querySelector('.project__next').getBoundingClientRect();
            let top = bounds.top + this.currentScroll;
            let left = bounds.left;
            let width = bounds.width;
            let height = bounds.height;
            this.nextMesh.position.y = this.currentScroll - top + this.height/2 - height/2;
            this.nextMesh.position.x = left - this.width/2 + width/2;
        }

    }

    onScroll() {
        window.ss.on("scroll", function (args) {

            this.scrollSpeed = args.speed;

            this.setNextPosition();
            this.setImagePosition();
            this.setVideoPosition();


            if (document.querySelector('.project__next-wrap') != null) {
                if (document.querySelector('.project__next-wrap').classList.contains('in-view')) {
                    gsap.to(this.nextMeshMAT.uniforms.uAlpha,{
                        duration: 1.25,
                        value: 1.,
                        delay: .25
                    })
                }
            }


            if (document.querySelector('.project-video') != null) {
                if (document.querySelector('.project-video').classList.contains('in-view')) {


                    gsap.to(this.videoMaterial.uniforms.uAlpha,{
                        value: 1.,
                        duration: .5,
                        delay: .45,
                    })


                }

            }




        }.bind(this));
    }

    indexInParent(node) {
        var children = node.parentNode.childNodes;
        var num = 0;
        for (var i=0; i<children.length; i++) {
            if (children[i]==node) return num;
            if (children[i].nodeType==1) num++;
        }
        return -1;
    }

    mouseMovement(e){


        this.ripMAT.uniforms.uSize.value = 1.;

        const mousePos = {
            x: e.targetTouches ? e.targetTouches[0].clientX : e.clientX,
            y: e.targetTouches ? e.targetTouches[0].clientY : e.clientY,
        };

        this.mouse.last.copy(this.mouse.current);

        this.mouse.updateVelocity = true;

        if(!this.mouse.lastTime) {
            this.mouse.lastTime = (performance || Date).now();
        }

        if(
            this.mouse.last.x === 0
            && this.mouse.last.y === 0
            && this.mouse.current.x === 0
            && this.mouse.current.y === 0
        ) {
            this.mouse.updateVelocity = false;
        }

        this.mouse.current.set(mousePos.x, mousePos.y);

        // divided by a frame duration (roughly)
        if(this.mouse.updateVelocity) {
            const time = (performance || Date).now();
            const delta = Math.max(14, time - this.mouse.lastTime);
            this.mouse.lastTime = time;

            this.mouse.velocity.set(
                (this.mouse.current.x - this.mouse.last.x) / delta,
                (this.mouse.current.y - this.mouse.last.y) / delta
            );
            this.mouse.velocity.set(this.lerp(this.mouse.velocity.x, 0, 0.05), this.lerp(this.mouse.velocity.y, 0, 0.1));
        }



    }

    addNextTexture() {

        let VS = require("./../shader/image/vertexShader.glsl");
        let FS = require("./../shader/image/fragmentShader.glsl");



        this.nextTextureMaterial = new THREE.ShaderMaterial({
            uniforms:{
                uImage: {value:0},
            },
            side: THREE.DoubleSide,
            vertexShader: VS.default,
            fragmentShader: FS.default,
            wireframe: false,

        })



        this.nextTextureGeometry = new THREE.PlaneBufferGeometry(1,1);

        this.marqueeTexture = new THREE.TextureLoader().load(nextIMG,texture=>{
            this.asR = texture.image.naturalWidth/texture.image.naturalHeight;
        });

        this.marqueeTextureLight = new THREE.TextureLoader().load(nextIMGLight,texture=>{

        });

        //texture.minFilter = THREE.LinearMipmapNearestFilter

        if (document.body.classList.contains('dark-mode')) {
            this.setTextureLight();
        } else {
            this.setTextureDark();

        }

        this.nextTextureMesh = new THREE.Mesh(this.nextTextureGeometry,this.nextTextureMaterial);
        this.nextTextureMesh.scale.set(0,0,0);


        // Render Target setup
        this.renderTargetText = new THREE.WebGLRenderTarget(this.width*window.devicePixelRatio, this.height*window.devicePixelRatio, {
            generateMipmaps: true
        });
        this.renderTargetTextScene = new THREE.Scene();
        this.renderTargetTextScene.add(this.nextTextureMesh);

        this.createNextMesh();

    }

    setTextureLight() {
        this.nextTextureMaterial.uniforms.uImage.value = this.marqueeTextureLight;
    }

    setTextureDark() {
        this.nextTextureMaterial.uniforms.uImage.value = this.marqueeTexture;
    }

    createNextMesh() {
        
        this.nextMeshGEO = new THREE.BoxGeometry(1, 1, 1, 64, 64, 64);

        let vert = require("./../shader/project/text/VS.glsl");
        let frag = require("./../shader/project/text/FS.glsl");

        this.nextMeshMAT = new THREE.ShaderMaterial({
            uniforms: {
                uTime : { value: 0 },
                uTexture: { value: this.renderTargetText.texture },
                uTexture2: { value: 0 },
                uTextASR: { value: this.asR },
                uTwist: { value: 0.0 },
                uSpeed: { value: 0.5 },
                uAlpha: { value: 0.0 },
                uResolution: { value: new THREE.Vector2( this.width, this.height ) },
            },
            defines: {
                PI: Math.PI
            },
            vertexShader : vert.default,
            fragmentShader : frag.default,
            side: THREE.DoubleSide,
            //transparent: true,
            //wireframe: true,
        });

        this.nextMesh = new THREE.Mesh(this.nextMeshGEO, this.nextMeshMAT);

        this.nextMesh.scale.set(0,0,0);

        
        this.sceneBG.add(this.nextMesh);



        this.tl.to(this.nextMeshMAT.uniforms.uTwist,{
            value: 2.0,
            duration: 1.0,
            ease: Power3.easeInOut
        })
        .add('twisted')
        .to(this.nextMeshMAT.uniforms.uTwist,{
            value: 0.0,
            duration: 1.0,
            ease: Power3.easeInOut
        },'+=2.').add('end');
        
    }

    addVideo() {

        let videoVS = require("./../shader/project/video/VS.glsl");
        let videoFS = require("./../shader/project/video/FS.glsl");

        this.video = document.querySelector( '.project-video' );
        this.video.play();
        this.videoWrapper = this.video.closest('div');

        const texture = new THREE.VideoTexture( this.video );

        this.videoGeometry = new THREE.PlaneBufferGeometry(1, 1);

        this.videoMaterial = new THREE.ShaderMaterial({
            uniforms: {
                exTexture : { value : texture },
                uMousePosition: { value: this.mouse.current},
                uResolution: { value: new THREE.Vector2( this.width, this.height ) },
                uPixelRatio: { value: this.devicePixelRatio },
                uAlpha: { value: 0 },
                uWidth: { value: this.video.offsetWidth },
                uHeight: { value: this.video.offsetHeight },
            },
            vertexShader: videoVS.default,
            fragmentShader: videoFS.default,
        });

        this.videoMesh = new THREE.Mesh(this.videoGeometry, this.videoMaterial);


        this.sceneBG.add(this.videoMesh);



    }

    setVideoPosition() {
        if (document.querySelector('.project-video') != null) {
            let bounds = document.querySelector('.project-video').getBoundingClientRect();
            let top = bounds.top + this.currentScroll;
            let left = bounds.left;
            let width = bounds.width;
            let height = bounds.height;
            if (typeof this.videoMesh != 'undefined') {
                this.videoMesh.position.y = this.currentScroll - top + this.height/2 - height/2;
                this.videoMesh.position.x = left - this.width/2 + width/2;
            }

        }
    }

    touchEnd() {
        this.ripMAT.uniforms.uSize.value = 0.;
    }

    resize() {


        if (window.matchMedia('(min-width:1200px)').matches) {
            this.renderer.setPixelRatio(Math.min(window.devicePixelRatio,1.0));
        }else {
            this.renderer.setPixelRatio(window.devicePixelRatio);
        }

        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;
        this.renderer.setSize( this.width,this.height );
        this.camera.aspect = this.width/this.height;
        this.camera.fov = 2*Math.atan( (this.height/2)/600 )* (180/Math.PI);
        this.camera.updateProjectionMatrix();
        this.setNextPosition();
        this.nextMesh.scale.set(this.width,this.width/this.asR,0.01);
        this.nextTextureMesh.scale.set(this.width,this.width/this.asR,1);
        this.ripMESH.scale.set(this.width,this.height,1);
        if (typeof this.videoMesh != 'undefined') {
            this.videoMesh.scale.set(this.video.offsetWidth,this.video.offsetHeight,1);
        }
        this.setImageSize();
        this.setImagePosition();
        this.setVideoPosition();
        this.finalMESH.scale.set(this.width,this.height,1);
        this.renderTargetImage.setSize(this.width*window.devicePixelRatio,this.height*window.devicePixelRatio)
        this.renderTargetText.setSize(this.width*window.devicePixelRatio,this.height*window.devicePixelRatio)

    }

    destroy() {
        this.go = false;
        this.container.innerHTML = '';
    }

    setupResize() {
        window.addEventListener("resize", this.resize.bind(this));
    }

    addRipples() {

        let ripplesFs = require("./../shader/project/ripplesFs.glsl");
        let ripplesVs = require("./../shader/project/ripplesVs.glsl");

        //PLANE BUFFER
        this.ripGEO = new THREE.PlaneBufferGeometry(1,1);

        this.ripMAT = new THREE.ShaderMaterial({
            uniforms:{
                "uTime": {value:-1},
                "uRipples": {type: "t",value: null},
                "uResolution": { value: new THREE.Vector2( this.width, this.height ) },
                "uPixelRatio": { value: this.devicePixelRatio },
                "uMousePosition": { value: this.mouse.current},
                "uVelocity": { value: this.mouse.velocity},
                "uViscosity": { value: 5.75},
                "uSpeed": { value: 2.75},
                "uSize": { value: 0.0},
                "uDissipation": { value: 0.9405},
            },
            side: THREE.DoubleSide,
            fragmentShader: ripplesFs.default,
            vertexShader: ripplesVs.default,
            //wireframe: true
        });


        this.ripMESH = new THREE.Mesh(this.ripGEO,this.ripMAT);

        this.scene.add(this.ripMESH)
        this.ripMESH.scale.set(this.width,this.height,1);

    }

    addFinal() {

        let VS = require("./../shader/project/CustomPass/vertexShader.glsl");
        let FS = require("./../shader/project/CustomPass/fragmentShader.glsl");

        //PLANE BUFFER
        this.finalGEO = new THREE.PlaneBufferGeometry(1,1);

        this.finalMAT = new THREE.ShaderMaterial({
            uniforms:{
                "tDepth" : { value: null },
                "tDiffuse": { value: null },
                "uImage": { value: this.renderTargetImage.texture },
                "BG": { value: null },
            },
            side: THREE.DoubleSide,
            fragmentShader: FS.default,
            vertexShader: VS.default,
            //wireframe: true
        });


        this.finalMESH = new THREE.Mesh(this.finalGEO,this.finalMAT);

        this.sceneFinal.add(this.finalMESH)
        this.finalMESH.scale.set(this.width,this.height,1);

    }

    addImages(){

        let VS = require("./../shader/project/image/VS.glsl");
        let FS = require("./../shader/project/image/FS.glsl");

        this.material = new THREE.ShaderMaterial({
            uniforms:{
                uImage: {value:0},
                uAlpha: {value:0},
            },
            side: THREE.DoubleSide,
            vertexShader: VS.default,
            fragmentShader: FS.default,
            wireframe: false
        })

        this.materials = []

        this.imageStore = this.images.map(img=>{

            let bounds = img.getBoundingClientRect()
            let geometry = new THREE.PlaneBufferGeometry(1,1);
            let texture = new THREE.Texture(img);
            texture.needsUpdate = true;
            let material = this.material.clone();

            this.materials.push(material);
            material.uniforms.uImage.value = texture;
            let mesh = new THREE.Mesh(geometry,material);

            var oneShot = false;

            window.addEventListener('scroll',function () {


                if (img.classList.contains('in-view') && oneShot == false) {


                    gsap.to(material.uniforms.uAlpha,{
                        value: 1.,
                        duration: .5,
                        delay: .25,
                        ease: Power2.easeIn
                    })



                    oneShot = true;
                }

            });

            this.sceneBG.add(mesh)

            return {
                img: img,
                mesh: mesh,
                top: bounds.top,
                left: bounds.left,
                width: bounds.width,
                height: bounds.height
            }
        });


    }

    setImagePosition() {

        if (typeof this.imageStore != 'undefined') {
            this.imageStore.forEach(o=>{
                let bounds = o.img.getBoundingClientRect();
                o.top = bounds.top + this.currentScroll;
                o.left = bounds.left;
                o.width = bounds.width;
                o.height = bounds.height;
                let dv = 8;
                if (window.matchMedia('(min-width:480px)').matches) {
                    dv = 2;
                }
                o.mesh.position.y = this.currentScroll -o.top + this.height/2 - o.height/dv;
                o.mesh.position.x = o.left - this.width/2 + o.width/dv;
            });
        }


    }

    setImageSize(){
        let dv = 4;
        if (window.matchMedia('(min-width:480px)').matches) {
            dv = 1;
        }

        this.imageStore.forEach(o=>{

            let bounds = o.img.getBoundingClientRect();
            o.width = bounds.width;
            o.height = bounds.height;

            o.mesh.scale.set(o.width/dv,o.height/dv,1);
        })
    }

    render() {

        if (this.go == true) {


            this.time++;

            this.nextMeshMAT.uniforms.uTime.value -= 0.01;
            this.nextMeshMAT.uniforms.uResolution.value = new THREE.Vector2( this.width, this.height );
            this.nextMeshMAT.uniforms.uTextASR.value = this.asR;

            //RIPPLES RENDER
            this.ripMAT.uniforms.uTime.value = this.time;
            this.ripMAT.uniforms.uResolution.value = new THREE.Vector2( this.width, this.height );
            this.ripMAT.uniforms.uMousePosition.value = new THREE.Vector2(this.mouse.current.x / this.width,(this.mouse.current.y - this.height) * -1 / this.height);
            this.ripMAT.uniforms.uVelocity.value = this.mouse.velocity.clone();

            this.renderer.setRenderTarget( this.renderTargetPing);
            this.renderer.render(this.scene,this.camera);
            this.ripMAT.uniforms.uRipples.value = this.renderTargetPing.texture;

            let temp = this.renderTargetPing;
            this.renderTargetPing = this.renderTargetPong;
            this.renderTargetPong = temp;
            this.finalMAT.uniforms["BG"].value = this.renderTargetPing.texture;
            this.renderer.setRenderTarget(null);

            //TEXT TWIST RENDER
            this.renderer.setRenderTarget(this.renderTargetText);
            this.renderer.render(this.renderTargetTextScene, this.camera);
            this.renderer.setRenderTarget(null);

            //BG RENDER
            this.renderer.setRenderTarget(this.renderTargetImage);
            this.renderer.render( this.sceneBG, this.camera );
            this.renderer.setRenderTarget(null);

            //FINAL SCENE
            this.renderer.render( this.sceneFinal, this.camera );
            this.renderer.setRenderTarget(null);


            requestAnimationFrame( this.render.bind(this) );

        }

    }

}
